"use strict";
const RETRY_MS = 5e3;
const STATES = {
  saved: "Guardado autom\xE1ticamente",
  saving: "Guardando\u2026",
  error: "Sin conexi\xF3n: se reintentar\xE1 guardar en unos segundos",
  expired: "Tu sesi\xF3n ha caducado. Inicia sesi\xF3n de nuevo: lo ya guardado se conserva",
  closed: "No se ha podido guardar: la validaci\xF3n ya no admite cambios"
};
const initFocasosAutosave = () => {
  var _a;
  const meta = document.querySelector("meta[name='focasos-autosave']");
  const form = document.querySelector("form.response-questionnaire");
  if (!meta || !form || form.dataset.focasosAutosave) {
    return;
  }
  form.dataset.focasosAutosave = "on";
  form.classList.add("focasos-autosave");
  const url = meta.content;
  const csrfToken = (_a = document.querySelector("meta[name='csrf-token']")) == null ? void 0 : _a.content;
  const actions = [];
  form.querySelectorAll(".question[data-question-id]").forEach((question) => {
    if (question.querySelector(".focasos-accion")) {
      actions.push([]);
    } else if (actions.length && question.querySelector("input[type='radio']")) {
      actions[actions.length - 1].push(question);
    }
  });
  const bar = document.createElement("div");
  bar.className = "focasos-autosave__bar";
  bar.innerHTML = "<span class='focasos-autosave__state' role='status' aria-live='polite'></span><span class='focasos-autosave__progress'></span>";
  form.appendChild(bar);
  const stateEl = bar.querySelector(".focasos-autosave__state");
  const progressEl = bar.querySelector(".focasos-autosave__progress");
  const setState = (state) => {
    bar.dataset.state = state;
    stateEl.textContent = STATES[state];
  };
  const updateProgress = () => {
    const done = actions.filter((qs) => qs.length && qs.every((q) => q.querySelector("input[type='radio']:checked"))).length;
    progressEl.textContent = `${done} de ${actions.length} acciones valoradas`;
  };
  const pending = /* @__PURE__ */ new Map();
  let inFlight = false;
  let retryTimer = null;
  let stopped = false;
  const flush = () => {
    if (inFlight || stopped || pending.size === 0) {
      return;
    }
    const [questionId, optionId] = pending.entries().next().value;
    pending.delete(questionId);
    inFlight = true;
    setState("saving");
    window.$.ajax({
      url,
      method: "POST",
      dataType: "json",
      headers: { "X-CSRF-Token": csrfToken },
      data: { question_id: questionId, response_option_id: optionId || "" }
    }).done(() => {
      inFlight = false;
      document.dispatchEvent(new CustomEvent("focasos:autosaved"));
      if (pending.size) {
        flush();
      } else {
        setState("saved");
      }
    }).fail((xhr) => {
      inFlight = false;
      if (!pending.has(questionId)) {
        pending.set(questionId, optionId);
      }
      if (xhr.status === 401) {
        stopped = true;
        setState("expired");
      } else if (xhr.status === 403 || xhr.status === 404 || xhr.status === 422) {
        stopped = true;
        setState("closed");
      } else {
        setState("error");
        clearTimeout(retryTimer);
        retryTimer = setTimeout(flush, RETRY_MS);
      }
    });
  };
  const save = (questionId, optionId) => {
    pending.set(questionId, optionId);
    flush();
  };
  const optionIdFor = (radio) => {
    var _a2, _b;
    return (_b = (_a2 = radio.closest(".js-collection-input")) == null ? void 0 : _a2.querySelector("input[type='hidden'][id$='_response_option']")) == null ? void 0 : _b.value;
  };
  let wasChecked = null;
  form.addEventListener("keydown", () => {
    wasChecked = null;
  });
  form.addEventListener("pointerdown", (event) => {
    var _a2;
    const radio = (_a2 = event.target.closest(".js-collection-input")) == null ? void 0 : _a2.querySelector("input[type='radio']");
    wasChecked = radio && form.contains(radio) ? radio.checked : null;
  });
  form.addEventListener("click", (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== "radio" || !wasChecked) {
      return;
    }
    wasChecked = null;
    const question = radio.closest(".question[data-question-id]");
    if (!question) {
      return;
    }
    radio.checked = false;
    save(question.dataset.questionId, "");
    updateProgress();
  });
  form.addEventListener("change", (event) => {
    var _a2;
    const radio = event.target;
    const question = (_a2 = radio.closest) == null ? void 0 : _a2.call(radio, ".question[data-question-id]");
    if (radio.type !== "radio" || !radio.checked || !question) {
      return;
    }
    wasChecked = null;
    save(question.dataset.questionId, optionIdFor(radio));
    updateProgress();
  });
  window.addEventListener("beforeunload", (event) => {
    if (!stopped && (inFlight || pending.size)) {
      event.preventDefault();
      event.returnValue = true;
    }
  });
  setState("saved");
  updateProgress();
};
document.addEventListener("turbo:load", initFocasosAutosave);
